import * as React from "react";
import Svg, { Path } from "react-native-svg";

const GalleryIcon = (props) => (
  <Svg
    width={29}
    height={30}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M25.874 8.845H3.126c-.402 0-.787.156-1.071.433a1.462 1.462 0 0 0-.444 1.046v14.352c0 .392.16.768.444 1.046.284.277.669.433 1.07.433h22.75c.401 0 .786-.156 1.07-.433.284-.278.444-.654.444-1.046V10.324c0-.392-.16-.768-.444-1.046a1.533 1.533 0 0 0-1.07-.433Zm-.096 15.736H3.222V10.42h22.556V24.58ZM24.28 3.337a.778.778 0 0 0-.236-.556.815.815 0 0 0-.57-.23H5.752a.815.815 0 0 0-.57.23.778.778 0 0 0-.236.556v.787H24.28v-.787ZM25.875 6.485a.778.778 0 0 0-.236-.557.815.815 0 0 0-.57-.23H4.124a.815.815 0 0 0-.57.23.778.778 0 0 0-.235.557v.786h22.556v-.786Z"
      fill={props.color}
    />
    <Path
      d="M10.327 22.056a1.38 1.38 0 0 0 1.305.102l7.87-3.43c.244-.104.45-.274.596-.49a1.307 1.307 0 0 0 0-1.46 1.353 1.353 0 0 0-.595-.49l-7.87-3.43a1.399 1.399 0 0 0-1.302.1 1.35 1.35 0 0 0-.457.482 1.313 1.313 0 0 0-.167.637v6.862c0 .221.057.44.166.635.108.195.264.36.454.482Zm.508-7.979a.225.225 0 0 1 .112-.196.247.247 0 0 1 .13 0 .222.222 0 0 1 .096 0l7.87 3.422a.232.232 0 0 1 .108.088c.026.04.04.086.037.133a.217.217 0 0 1-.037.128.225.225 0 0 1-.108.084l-7.87 3.43a.23.23 0 0 1-.226 0 .246.246 0 0 1-.112-.196v-6.893Z"
      fill={props.color}
    />
  </Svg>
);
GalleryIcon.defaultProps = {
  color: "#F8F8F8",
};

export default GalleryIcon;
